import _classCallCheck from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a, _b, _c;
import { LinearSRGBColorSpace, SRGBColorSpace, Vector2 } from 'three';
import { $threeTexture } from './image.js';
import { Texture } from './texture.js';
var $texture = Symbol('texture');
var $transform = Symbol('transform');
export var $materials = Symbol('materials');
export var $usage = Symbol('usage');
var $onUpdate = Symbol('onUpdate');
var $activeVideo = Symbol('activeVideo');
// Defines what a texture will be used for.
export var TextureUsage;
(function (TextureUsage) {
  TextureUsage[TextureUsage["Base"] = 0] = "Base";
  TextureUsage[TextureUsage["MetallicRoughness"] = 1] = "MetallicRoughness";
  TextureUsage[TextureUsage["Normal"] = 2] = "Normal";
  TextureUsage[TextureUsage["Occlusion"] = 3] = "Occlusion";
  TextureUsage[TextureUsage["Emissive"] = 4] = "Emissive";
  TextureUsage[TextureUsage["Clearcoat"] = 5] = "Clearcoat";
  TextureUsage[TextureUsage["ClearcoatRoughness"] = 6] = "ClearcoatRoughness";
  TextureUsage[TextureUsage["ClearcoatNormal"] = 7] = "ClearcoatNormal";
  TextureUsage[TextureUsage["SheenColor"] = 8] = "SheenColor";
  TextureUsage[TextureUsage["SheenRoughness"] = 9] = "SheenRoughness";
  TextureUsage[TextureUsage["Transmission"] = 10] = "Transmission";
  TextureUsage[TextureUsage["Thickness"] = 11] = "Thickness";
  TextureUsage[TextureUsage["Specular"] = 12] = "Specular";
  TextureUsage[TextureUsage["SpecularColor"] = 13] = "SpecularColor";
  TextureUsage[TextureUsage["Iridescence"] = 14] = "Iridescence";
  TextureUsage[TextureUsage["IridescenceThickness"] = 15] = "IridescenceThickness";
  TextureUsage[TextureUsage["Anisotropy"] = 16] = "Anisotropy";
})(TextureUsage || (TextureUsage = {}));
/**
 * TextureInfo facade implementation for Three.js materials
 */
export var TextureInfo = /*#__PURE__*/function () {
  function TextureInfo(onUpdate, usage, threeTexture, material) {
    _classCallCheck(this, TextureInfo);
    this[_a] = null;
    this[_b] = {
      rotation: 0,
      scale: new Vector2(1, 1),
      offset: new Vector2(0, 0)
    };
    this[_c] = false;
    // Creates image, sampler, and texture if valid texture info is provided.
    if (threeTexture) {
      this[$transform].rotation = threeTexture.rotation;
      this[$transform].scale.copy(threeTexture.repeat);
      this[$transform].offset.copy(threeTexture.offset);
      this[$texture] = new Texture(onUpdate, threeTexture);
    }
    this[$onUpdate] = onUpdate;
    this[$materials] = material;
    this[$usage] = usage;
  }
  _createClass(TextureInfo, [{
    key: "texture",
    get: function get() {
      return this[$texture];
    }
  }, {
    key: "setTexture",
    value: function setTexture(texture) {
      var _this = this;
      var _d, _e;
      var threeTexture = texture != null ? texture.source[$threeTexture] : null;
      var oldTexture = (_d = this[$texture]) === null || _d === void 0 ? void 0 : _d.source[$threeTexture];
      if (oldTexture != null && oldTexture.isVideoTexture) {
        this[$activeVideo] = false;
      } else if ((_e = this[$texture]) === null || _e === void 0 ? void 0 : _e.source.animation) {
        this[$texture].source.animation.removeEventListener('enterFrame', this[$onUpdate]);
      }
      this[$texture] = texture;
      if (threeTexture != null && threeTexture.isVideoTexture) {
        var element = threeTexture.image;
        this[$activeVideo] = true;
        if (element.requestVideoFrameCallback != null) {
          var update = function update() {
            if (!_this[$activeVideo]) {
              return;
            }
            _this[$onUpdate]();
            element.requestVideoFrameCallback(update);
          };
          element.requestVideoFrameCallback(update);
        } else {
          var _update = function _update() {
            if (!_this[$activeVideo]) {
              return;
            }
            _this[$onUpdate]();
            requestAnimationFrame(_update);
          };
          requestAnimationFrame(_update);
        }
      } else if ((texture === null || texture === void 0 ? void 0 : texture.source.animation) != null) {
        texture.source.animation.addEventListener('enterFrame', this[$onUpdate]);
      }
      var colorSpace = SRGBColorSpace;
      if (this[$materials]) {
        var _iterator = _createForOfIteratorHelper(this[$materials]),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var material = _step.value;
            switch (this[$usage]) {
              case TextureUsage.Base:
                material.map = threeTexture;
                break;
              case TextureUsage.MetallicRoughness:
                colorSpace = LinearSRGBColorSpace;
                material.metalnessMap = threeTexture;
                material.roughnessMap = threeTexture;
                break;
              case TextureUsage.Normal:
                colorSpace = LinearSRGBColorSpace;
                material.normalMap = threeTexture;
                break;
              case TextureUsage.Occlusion:
                colorSpace = LinearSRGBColorSpace;
                material.aoMap = threeTexture;
                break;
              case TextureUsage.Emissive:
                material.emissiveMap = threeTexture;
                break;
              case TextureUsage.Clearcoat:
                material.clearcoatMap = threeTexture;
                break;
              case TextureUsage.ClearcoatRoughness:
                material.clearcoatRoughnessMap = threeTexture;
                break;
              case TextureUsage.ClearcoatNormal:
                material.clearcoatNormalMap = threeTexture;
                break;
              case TextureUsage.SheenColor:
                material.sheenColorMap = threeTexture;
                break;
              case TextureUsage.SheenRoughness:
                material.sheenRoughnessMap = threeTexture;
                break;
              case TextureUsage.Transmission:
                material.transmissionMap = threeTexture;
                break;
              case TextureUsage.Thickness:
                material.thicknessMap = threeTexture;
                break;
              case TextureUsage.Specular:
                material.specularIntensityMap = threeTexture;
                break;
              case TextureUsage.SpecularColor:
                material.specularColorMap = threeTexture;
                break;
              case TextureUsage.Iridescence:
                material.iridescenceMap = threeTexture;
                break;
              case TextureUsage.IridescenceThickness:
                material.iridescenceThicknessMap = threeTexture;
                break;
              case TextureUsage.Anisotropy:
                material.anisotropyMap = threeTexture;
                break;
              default:
            }
            material.needsUpdate = true;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      if (threeTexture) {
        // Updates the colorSpace for the texture, affects all references.
        threeTexture.colorSpace = colorSpace;
        threeTexture.rotation = this[$transform].rotation;
        threeTexture.repeat = this[$transform].scale;
        threeTexture.offset = this[$transform].offset;
      }
      this[$onUpdate]();
    }
  }]);
  return TextureInfo;
}();
_a = $texture, _b = $transform, _c = $activeVideo;